import React from "react";
import { Section, SectionHeading, Reveal } from "./Primitives";
import { CASE_STUDIES } from "../../data/content";
import { useSiteContent } from "../../context/SiteContentContext";
import { CardSkeleton } from "./Skeletons";

export const CaseStudies = () => {
  const { case_studies, loading } = useSiteContent();
  return (
    <Section id="case-studies">
      <SectionHeading overline={CASE_STUDIES.overline} title={CASE_STUDIES.title} intro={CASE_STUDIES.intro} />

      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
        {loading
          ? Array.from({ length: 2 }).map((_, i) => <CardSkeleton key={i} h="h-56" />)
          : case_studies.map((item, i) => {
              const c = item.data;
              return (
                <Reveal key={item.id} delay={i * 0.1} className="group rounded-3xl overflow-hidden border border-white/5 bg-white/[0.015] flex flex-col">
                  <div className="relative h-56 md:h-64 overflow-hidden">
                    <img
                      src={c.image}
                      alt={c.title}
                      loading="lazy"
                      className="absolute inset-0 h-full w-full object-cover brightness-[0.5] transition-all duration-700 group-hover:brightness-75 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-void via-void/40 to-transparent" />
                    {c.draft && (
                      <span className="absolute top-5 right-5 rounded-full bg-brand/20 backdrop-blur-md border border-brand/40 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.18em] text-brand" data-testid="case-study-draft">
                        Draft
                      </span>
                    )}
                    <div className="absolute inset-x-0 bottom-0 p-8">
                      <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-brand">{c.sector}</span>
                      <h3 className="mt-3 font-heading text-2xl md:text-3xl font-medium text-white max-w-sm leading-tight">
                        {c.title}
                      </h3>
                    </div>
                  </div>

                  <div className="p-8 md:p-10 flex-1 flex flex-col">
                    {c.summary && (
                      <p className="text-sm md:text-base leading-relaxed text-muted-foreground">{c.summary}</p>
                    )}
                    {Array.isArray(c.metrics) && c.metrics.length > 0 && (
                      <div className="mt-8 grid grid-cols-3 gap-4 pt-6 border-t border-white/5">
                        {c.metrics.map((m, mi) => (
                          <div key={mi}>
                            <div className="font-heading text-2xl md:text-3xl font-light text-white">{m.value}</div>
                            <div className="mt-1 text-xs text-muted-foreground leading-snug">{m.label}</div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </Reveal>
              );
            })}
      </div>
    </Section>
  );
};

export default CaseStudies;
